import React, { useEffect, useState } from 'react'
import { DrawTypes } from '../../../features/drawSlice';
import { setPanoCoordinate, setViewAngle, setViewFov } from '../../../features/panoSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { DrawPlugin, PanoGL, ScalablePlugin, SoftTextPlugin } from '../easy-pano-imports';
import './Panorama.css'
import { setMapZoom } from '../../../features/mapSlice';

const ankapanapiOptions = {
    content: 'panodiv',
    aroundService: `${process.env.REACT_APP_BASE_URL}pano/around/`,
    imageService: `${process.env.REACT_APP_BASE_URL}pano/img/`,
    tileService: `${process.env.REACT_APP_BASE_URL}pano/tile/`,
    pointCloudURL: `${process.env.REACT_APP_BASE_URL}pano/`
};

export default function Panorama() {

    const [pano, setPano] = useState<any>();
    const [draw, setDraw] = useState<any>();
    const drawType = useAppSelector(state => state.drawState.drawType)
    const panoCoordinate = useAppSelector(state => state.panoState.panoCoordinate)
    const panoGotoCoordinate = useAppSelector(state => state.panoState.panoGotoCoordinate)
    const displayPano = useAppSelector(state => state.toolbarState.showPano);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const panogl = new PanoGL(ankapanapiOptions);
        setPano(panogl);
        (window as any).pano = panogl;
        panogl.setCompassVisibility(false);
        panogl.setLabelVisibility(false);


        const softtext = new SoftTextPlugin();
        panogl.setPlugin(softtext);

        const scalable = new ScalablePlugin();
        panogl.setPlugin(scalable);

        const draw = new DrawPlugin();
        panogl.setPlugin(draw);
        setDraw(draw);


        panogl.gotoLocation(39.97679792936009, 32.55952766405587);

        panogl.getTilePlugin()._zoomLevels = [1, 0.9, 0]
        panogl.start();

        panogl.addEvent(PanoGL.LOCATION_CHANGE, null, (e: any) => { dispatch(setPanoCoordinate([e.lon, e.lat])); });
        panogl.addEvent(PanoGL.VIEW_ANGLE_CHANGE, null, (e: any) => {
            dispatch(setViewAngle(e.rotationY)); dispatch(setViewFov(e.fov));
        });

        scalable.getMainSketchLayer().setStyle({
            lineWidth: 2,
            lineColor: '#00FFFF',
            fillColor: '#00FFFF',
            fillOpacity: 0.3,
            lineOpacity: 1
        })
    }, [])

    useEffect(() => {
        if (pano) {
            pano.lookAtY(204.3365695792881);
        }
    }, [pano])

    useEffect(() => {
        if (displayPano) {
            dispatch(setMapZoom(15))
            dispatch(setPanoCoordinate([32.55952766405587,39.97679792936009]));
        }
    }, [displayPano])


    useEffect(() => {
        if (!displayPano) {
            return
        }
        switch (drawType) {
            case DrawTypes.POINT:
                draw.startPoint();
                break;
            case DrawTypes.LINESTRING:
                draw.startLine();
                break;
            case DrawTypes.POLYGON:
                draw.startPolygon();
                break;
            case DrawTypes.CLEAR:
                pano.getScalable().getMainSketchLayer().refresh();
                pano.getScalable().getMainSketchLayer().removeAll();
                pano.getScalable().getMainSketchLayer().refresh();
                break;
            default:
                break;
        }
        return () => {

        }
    }, [drawType])

    useEffect(() => {
        if (panoGotoCoordinate && pano) {
            pano.gotoLocation(panoGotoCoordinate[1], panoGotoCoordinate[0]);
        }

    }, [panoGotoCoordinate])

    return (
        <div id='panodiv' tabIndex={0} style={{ width: '100%', display: 'flex', margin: '0' }}></div>
    )
}
